export default __webpack_public_path__ + "static/media/manageac_navicon.054a268a.svg";